import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { withRouter } from 'react-router-dom';

import CheckoutForm from './Form';
import { getClientSecret } from '../../services/providers/payments';

// const stripePromise = loadStripe('pk_test_qiQLarNYROIQWOFfTq61bm5A00ae1BBZbf');
const stripePromise = loadStripe('pk_live_Vq90rSReY137ZVqDhDDV3xYH00N2xTHb4X');

function StripeSecretWrapper({ location, history }) {
  const [id, setId] = useState('');
  const [clientSecret, setClientSecret] = useState('');

  useEffect(() => {
    if (!location.state) {
      history.replace('/');
      return;
    }

    getClientSecret()
      .then(({ id, client_secret }) => {
        setId(id);
        setClientSecret(client_secret);
      });
  }, []);

  const options = {
    clientSecret,
    // appearance,
    fonts: [
      { cssSrc: 'https://fonts.googleapis.com/css?family=Roboto' },
    ],
  };

  return (
    <div className="App">
      {clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm id={id} clientSecret={clientSecret} />
        </Elements>
      )}
    </div>
  );
}

export default withRouter(StripeSecretWrapper);



// WEBPACK FOOTER //
// ./src/containers/Payment/StripeWrapper.js